export default {
  year: 2022,
  edition: "제 18회",
  date: "2022년 11월 26일 토요일",
  time: "오후 2시 ~ 5시",
  location: "다산관 D104/D105",
  links: {
    problems: {
      BOJ: "https://www.acmicpc.net/category/697",
    },
    solutions: {
      PDF: "/downloads/spc/2022/solutions.pdf",
    },
  },
  authors: ["김동건", "강효규", "박수현", "이윤제", "임지환", "조원빈"],
  contests: [
    {
      title: "SPC 2022 Master",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "6", "조성훈"],
        ["2", "6", "김민성"],
        ["3", "6", "안성훈"],
        ["4", "5", "채성우"],
        ["5", "5", "이재혁"],
        ["6", "5", "이준석"],
      ],
      award: ["gold", "silver", "silver", "bronze", "bronze", "bronze"],
      links: [["스코어보드", "https://www.acmicpc.net/contest/spotboard/896"]],
    },
    {
      title: "SPC 2022 Champion",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "6", "박재형"],
        ["2", "6", "이진우"],
        ["3", "6", "하건영"],
        ["4", "6", "이승재"],
        ["5", "5", "전민수"],
        ["6", "5", "조명재"],
        ["7", "5", "손기령"],
      ],
      award: [
        "winner",
        "gold",
        "silver",
        "silver",
        "bronze",
        "bronze",
        "bronze",
      ],
      links: [["스코어보드", "https://www.acmicpc.net/contest/spotboard/897"]],
    },
  ],
};
